import React from 'react';
import './style.css'
class PopUp extends React.Component {
    onClose = e => {
        this.props.onClose(true);
    }
    clickClose = e =>{
        if(e && e.target.className==="pop_up"){
            this.props.onClose(true);
        }
    }
    componentDidMount() {
        window.addEventListener('keydown', this.listenEsc);
    }
    componentWillUnmount(){
        window.removeEventListener('keydown', this.listenEsc);
    }
    listenEsc = e => {
        if (e.keyCode == 27) {
           this.props.onClose(true);
        }
    }
    render() {
        let cointainerCss = this.props.popUpContainer || ("pop_up_container bg_white border border_radius padding " + (this.props.containerClass || ""));

        return (
            <div className="pop_up" onClick={this.clickClose}>
                <div className="close_pop_up" onClick={this.onClose}>X</div>
                <div className={ cointainerCss }>
                    {this.props.children}
                </div>
            </div>
        )
    }
};

export default PopUp;



// WEBPACK FOOTER //
// ./src/components/PopUp/index.js